import { render, staticRenderFns } from "./InvoiceHeader.vue?vue&type=template&id=23633c98&scoped=true&"
import script from "./InvoiceHeader.vue?vue&type=script&lang=ts&"
export * from "./InvoiceHeader.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceHeader.vue?vue&type=style&index=0&id=23633c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23633c98",
  null
  
)

export default component.exports